import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import PlayerContainer from "./components/PlayerContainer";
import Playlist from "../../components/playlist/Playlist";
import Artists from "../../components/artists/Artists";
import NewsList from "../../components/news/NewsList";
import Slider from "../../components/slider/Slider";
import PlaylistsCarousel from "../../components/playlistsCarousel/PlaylistsCarousel";
import Contests from "../../components/contests/Сontests";
import HomeActiveСontests from "../contests/components/HomeActiveСontests";
import Button from "../../components/button/Button";
import { useAppDispatch, useAppSelector } from "../../hooks/redux-hooks";
import { selectMainState, setSEOSettings } from "../../store/slices/main";
import {
  artistsByContest,
  detailByContest,
  favoriteByContest,
} from "../../api/asyncThuncks/contestsCards";
import EmptyContent from "../../components/emptyContent/EmptyContent";
import PlaylistByContest from "../contests/components/playlist/PlaylistByContest";

const HomeContainer = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {
    addsSliderHomePage,
    contestsHomePagUrls,
    playlistHomePage,
    contestHomePage,
    loading,
    error,
    successMessageByVoteModal,
  } = useAppSelector(selectMainState);
  const [deviceType, setDeviceType] = useState("desktop");
  const currentDate = moment();
  const checkDate = moment(contestHomePage.details?.applicationButtonEndAt);
  const isDatePassed =
    checkDate.isBefore(currentDate, "day") &&
    !checkDate.isSame(currentDate, "day");

  const navigateAndSetSEOSettings = async (
    link: string,
    appTitle: string,
    appDescription: string,
    appImg: string,
    publicUrl?: string
  ) => {
    // if (publicUrl) await dispatch(contestCardByPublicUrl(publicUrl));
    navigate(`${link}`);
    dispatch(
      setSEOSettings({
        appTitle,
        appDescription,
        appImg,
      })
    );
  };

  useEffect(() => {
    setDeviceType(window.innerWidth < 768 ? "mobile" : "desktop");
  }, []);

  useEffect(() => {
    if (contestsHomePagUrls)
      // dispatch(contestCardByPublicUrl(`${contestsHomePage}`));
      dispatch(detailByContest(`${contestsHomePagUrls}`));
    dispatch(favoriteByContest(`${contestsHomePagUrls}`));
    dispatch(artistsByContest(`${contestsHomePagUrls}`));
  }, [contestsHomePagUrls]);

  useEffect(() => {
    if (successMessageByVoteModal) {
      dispatch(artistsByContest(`${contestsHomePagUrls}`));
    }
  }, [successMessageByVoteModal]);

  return (
    <>
      {!addsSliderHomePage?.length ? (
        <EmptyContent />
      ) : (
        <div className="flex flex-col w-screen max-w-xl md:max-w-[1000px] justify-center h-full ">
          {!!addsSliderHomePage?.length && <Slider deviceType={deviceType} />}

          {/* <PlayerContainer /> */}

          <div className="flex flex-col pt-[4rem] bg-white  w-full">
            {!!contestsHomePagUrls?.length && (
              <>
                <Contests />
                <div className="flex justify-center w-full md:flex-col">
                  <div className="min-w-[20.6rem] w-full md:px-0">
                    <div className="md:flex md:justify-around md:w-full">
                      <div className="w-full">
                        {contestHomePage && (
                          <>
                            <div className="px-5 md:px-0">
                              <div>
                                <div className="">
                                  {contestHomePage.details && (
                                    <HomeActiveСontests />
                                  )}
                                </div>
                              </div>
                              <div
                                className={`${
                                  !!contestHomePage.favorites.audioTracks
                                    ?.length
                                    ? "block"
                                    : "hidden"
                                }`}
                              >
                                {!!contestHomePage.favorites.audioTracks
                                  ?.length && (
                                  <PlaylistByContest
                                    title={contestHomePage.favorites.name}
                                    audioTracks={
                                      contestHomePage.favorites.audioTracks
                                    }
                                    contestId={contestHomePage?.details?.id}
                                  />
                                )}
                              </div>
                              <div
                                onClick={() => {
                                  if (contestHomePage.details)
                                    navigateAndSetSEOSettings(
                                      `contests/${contestsHomePagUrls}`,
                                      contestHomePage.details.title,
                                      contestHomePage.details.description,
                                      contestHomePage.details.imgPath,
                                      `${contestsHomePagUrls}`
                                    );
                                }}
                              >
                                {!!contestHomePage.favorites.audioTracks
                                  ?.length && (
                                  <Button
                                    title="Показати всі деталі"
                                    className={`mt-5 mb-[2rem] bg-light_gray md:bg-light_gray md:bg-opacity-30 transition-opacity hover:opacity-80 hover:transition-opacity`}
                                  />
                                )}
                              </div>
                            </div>
                            <div className="pl-5 md:pl-0">
                              {contestHomePage.artists && (
                                <Artists
                                  title={"Конкурсанти"}
                                  artists={contestHomePage.artists}
                                />
                              )}
                              {/* {!isDatePassed && (
                                <div className="pr-5 md:pt-5 md:pr-0">
                                  <Button
                                    onClick={() => {
                                      if (contestHomePage.details)
                                        navigateAndSetSEOSettings(
                                          `/application/${contestsHomePagUrls}`,
                                          contestHomePage.details.title,
                                          contestHomePage.details.description,
                                          contestHomePage.details.imgPath,
                                          `${contestsHomePagUrls}`
                                        );
                                    }}
                                    title="Подати заявку на участь"
                                    className="bg-light_gray text-[#202124] md:bg-light_gray md:bg-opacity-30 transition-opacity hover:opacity-80 hover:transition-opacity"
                                  />
                                </div>
                              )} */}
                              <div className="border-b border-light_gray pt-[4rem] mr-5 mb-[4rem]"></div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {playlistHomePage && (
              <PlaylistsCarousel
                title={"Підбірки редакції"}
                playlists={playlistHomePage}
              />
            )}

            {/* <Podcasts /> */}

            <div className="">
              <div className="flex items-center px-5 md:px-0">
                <h2 className="text-xl pr-2.5 text-black font-bold">
                  Новини
                </h2>
                <span
                  onClick={() =>
                    navigateAndSetSEOSettings(
                      "/news",
                      "Новини",
                      "У «Сільпо» ми завжди допоможемо представникам ЗМІ з інформацією. Читайте наші свіжі прес-релізи та, якщо потрібно, звертайтеся до прес-служби в будь-який час. e-mail: press@fozzy.ua",
                      ""
                    )
                  }
                  className="opacity-70 text-[13px] pt-1 hover:opacity-100 cursor-pointer"
                >
                  Переглянути всі
                </span>
              </div>
              <div className="pl-5 md:pl-0">
                <NewsList />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HomeContainer;
